const KB = 1024;

/** Human-readable size: B below 1 KB, then KB, MB, GB with one decimal. */
export function formatBytes(bytes: number): string {
  if (bytes < KB) return `${String(bytes)} B`;
  const units = ["KB", "MB", "GB"];
  let value = bytes / KB;
  let unit = 0;
  while (value >= KB && unit < units.length - 1) {
    value /= KB;
    unit += 1;
  }
  return `${value.toFixed(1)} ${units[unit] ?? "GB"}`;
}

export function formatDateTime(value: string | null): string {
  return value === null ? "-" : new Date(value).toLocaleString();
}

/**
 * Id prefix (hex and dashes), Telegram id (digits) or @username. The server
 * decides what it resolves; this only rejects text it can never match.
 */
const USER_QUERY = /^@?[A-Za-z0-9_-]{1,64}$/;

export const USER_QUERY_MAX = 64;

export function isValidUserQuery(query: string): boolean {
  const trimmed = query.trim();
  return trimmed === "" || USER_QUERY.test(trimmed);
}

const SHORT_ID_LENGTH = 8;

export function shortUserId(userId: string): string {
  return userId.slice(0, SHORT_ID_LENGTH);
}

function nonEmpty(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed === undefined || trimmed === "" ? null : trimmed;
}

export interface UserLabel {
  primary: string;
  secondary: string | null;
}

/**
 * Display name first, Telegram id second; the short id stands in when both
 * are null (PII redacted, or the name was not captured yet).
 */
export function userLabel(user: {
  user_id: string;
  display_name?: string | null;
  telegram_id?: string | null;
}): UserLabel {
  const name = nonEmpty(user.display_name);
  const telegram = nonEmpty(user.telegram_id);
  if (name !== null) return { primary: name, secondary: telegram };
  if (telegram !== null) return { primary: telegram, secondary: null };
  return { primary: shortUserId(user.user_id), secondary: null };
}
